import React from 'react';

export default function DwellCursor({ cursorData, requiredGesture = 'PEACE_V' }) {
  if (!cursorData || !cursorData.visible) {
    return null;
  }

  const {
    x,
    y,
    progress = 0,
    isCooldown = false,
    cooldownRemaining = 0,
    gestureMatch,
  } = cursorData;

  const radius = 34;
  const strokeWidth = 6;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - progress * circumference;

  // Golden Dwell Ring Theme
  const goldBase = '#f5b83d';
  const goldTrack = 'rgba(245, 184, 61, 0.35)';

  return (
    <div
      className="fixed pointer-events-none z-50 transform -translate-x-1/2 -translate-y-1/2 transition-transform duration-75 ease-out"
      style={{ left: `${x}px`, top: `${y}px` }}
    >
      <div className="relative flex items-center justify-center rounded-full shadow-[0_0_30px_rgba(245,184,61,0.6)]">
        
        {/* SVG Radial Dwell Ring */}
        <svg
          className="w-24 h-24 transform -rotate-90"
          viewBox="0 0 88 88"
        >
          {/* Golden Semi-Transparent Track */}
          <circle
            cx="44"
            cy="44"
            r={radius}
            stroke={goldTrack}
            fill="rgba(8, 14, 33, 0.4)"
            strokeWidth={strokeWidth}
          />

          {/* Active Golden Progress Ring */}
          {gestureMatch && !isCooldown && (
            <circle
              cx="44"
              cy="44"
              r={radius}
              stroke={goldBase}
              fill="transparent"
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="transition-all duration-75 ease-linear"
            />
          )}

          {/* Cooldown Ring */}
          {isCooldown && (
            <circle
              cx="44"
              cy="44"
              r={radius}
              stroke="#fbbf24"
              fill="rgba(251, 191, 36, 0.2)"
              strokeWidth={strokeWidth}
              className="animate-pulse"
            />
          )}
        </svg>

        {/* Center Indicator Dot */}
        <div className="absolute w-5 h-5 rounded-full bg-[#f5b83d] animate-ping opacity-75" />
        <div className="absolute w-4 h-4 rounded-full bg-[#f5b83d] border-2 border-white shadow-md flex items-center justify-center" />

        {/* Cooldown Badge */}
        {isCooldown && cooldownRemaining > 0 && (
          <div className="absolute top-14 bg-amber-900/90 text-amber-200 text-[10px] font-bold px-2.5 py-0.5 rounded-full border border-amber-500/50 shadow-lg whitespace-nowrap">
            Wait {cooldownRemaining}s
          </div>
        )}

      </div>
    </div>
  );
}
